import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format, distanceInWords, isDate, isValid, parse } from "date-fns";

import styles from "./HumanReadableDate.m.scss";

function HumanReadableDate(props) {
  const { theme, date, locale, dateFormat, NoDate } = props;

  if (typeof date === "string") {
  }

  return (typeof date === "string" &&
    isDate(parse(date)) &&
    isValid(parse(date))) ||
    (isDate(date) && isValid(date)) ? (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.formatted)}>
        {format(date, dateFormat)}
      </div>
      <div className={classnames(theme.text)}>
        {distanceInWords(new Date(), date, {
          addSuffix: true,
          locale,
        })}
      </div>
    </div>
  ) : (
    NoDate
  );
}

HumanReadableDate.displayName = "HumanReadableDate";

HumanReadableDate.propTypes = {
  theme: PropTypes.object,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  dateFormat: PropTypes.string,
  locale: PropTypes.object,
  NoDate: PropTypes.node,
};

HumanReadableDate.defaultProps = {
  dateFormat: "HH:mm:ss DD.MM.YYYY",
  NoDate: <div />,
};

export default themr("@lifepay/HumanReadableDate", styles)(HumanReadableDate);



// WEBPACK FOOTER //
// ./src/components/utils/HumanReadableDate/HumanReadableDate.js